<template>
  <div>
    <bread-crumb></bread-crumb>
    <main-content :surveyInfo="surveyInfo" :loading="loading" @delete="handleDelete" @update="handleUpdate" @refresh="handleRefresh" @search="handleSearch"></main-content>
  </div>
</template>

<script>
import BreadCrumb from './components/Breadcrumb'
import MainContent from './components/MainContent'
import PagePagination from './components/Page'
import API from 'api/api_authority'

import { mapState } from 'vuex'

export default {
  name: 'Role',
  components: {
    BreadCrumb,
    MainContent,
    PagePagination
  },
  data () {
    return {
      page: 1,
      size: 10,
      total: 0,
      currentPage: 1,
      surveyInfo: [],
      loading: true,
      search: {}// 搜索条件
    }
  },
  computed: {
    ...mapState(['token'])
  },
  methods: {
    // 获取用户列表信息
    getInfo (pageNum, pageSize, search) {
      let that = this
      let params = {pageNum, pageSize}
      Object.assign(params, search)
      that.loading = true
      API.findList(params).then((res) => {
        if (res.code === 0) {
          that.loading = false
          that.surveyInfo = res.data
          that.total = res.data.totalNum
        } else {
          that.$message.error('网络错误')
        }
      })
    },
    // 新增后刷新信息
    handleRefresh () {
      this.currentPage = 1
      this.getInfo(1, this.size)
    },
    // 分页加载
    handlePage (currentPage) {
      this.currentPage = currentPage
      this.getInfo(currentPage, this.size)
    },
    // 改变每页条数
    handlesize (val) {
      this.size = val
      this.getInfo(1, this.size)
    },
    // 避免删除后刷新到首页
    handleDelete (index) {
      this.surveyInfo.splice(index, 1)
    },
    // 避免修改后返回首页
    handleUpdate () {
      this.page = this.currentPage
      this.getInfo(this.page, this.size)
    },
    // 搜索
    handleSearch (params) {
      this.search = params
      this.getInfo(this.page, this.size, this.search)
    }
  },
  mounted () {
    let infoPage = this.page
    let infoSize = this.size
    this.getInfo(infoPage, infoSize)
  }
}
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/authority/Authority.vue